import {
    RETRIEVE_REVIEWS,
    DELETE_REVIEW,
    RESTORE_REVIEW,
    UPDATE_REVIEW_STATUS,
} from "../actions/types";
  
  const initialState = { reviews : [], totalReviewCount : 0 };

const reviewReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_REVIEWS:
      return {
        reviews: payload.rows,
        totalReviewCount: payload.count,
      };

    case UPDATE_REVIEW_STATUS:
      return {
        reviews: payload.rows,
        totalReviewCount: payload.count,
      };

    case DELETE_REVIEW:
      return {
        reviews: payload.rows,
        totalReviewCount: payload.count,
      };

    case RESTORE_REVIEW:
      return {
        reviews: payload.rows,
        totalReviewCount: payload.count,
      };

    default:
      return state;
  }
};

export default reviewReducer;